import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useAtomValue, useSetAtom } from "jotai"
import StylesList, { StylesListType } from "./StylesList"
import { currentDisplayedStylesAtom } from "@/store/style/polarr-styles"
import { StyleResponseDTO } from "@/api/dto/styles"
import { internalStylesAtom } from "@/store/style/style-state"
import { analytics } from "@/telemetry/amplitude"

export const InternalStylesPanel = (props: {
	onSelect: (style: StyleResponseDTO | undefined) => void
	selectedStyle: StyleResponseDTO | undefined
	isFullWidth?: boolean
	stylesListType: StylesListType
	onViewClicked?: (style: StyleResponseDTO) => void
}) => {
	const { t } = useTranslation("components")
	const internalStyles = useAtomValue(internalStylesAtom)
	const setCurrentDisplayedStyles = useSetAtom(currentDisplayedStylesAtom)

	useEffect(() => {
		setCurrentDisplayedStyles(internalStyles.data)
	}, [internalStyles, setCurrentDisplayedStyles])

	const handleSelect = (style: StyleResponseDTO, target?: EventTarget) => {
		analytics.trackEvent(
			{
				type: "click",
				label: "select_internal_style",
				value: style.name,
			},
			target,
		)
		props.onSelect(style)
	}

	return (
		<div className="flex flex-col">
			<div className="flex-1">
				{internalStyles.data.length > 0 ? (
					<StylesList
						type={props.stylesListType}
						styles={internalStyles.data}
						onSelect={handleSelect}
						selectedStyle={props.selectedStyle}
						isFullWidth={props.isFullWidth}
						onViewClicked={props.onViewClicked}
					/>
				) : (
					<div className="flex size-full items-center justify-center py-12">
						<div className="text-center text-sm text-base-400">
							{t("internalStylesPanel.noStyles")}
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
